import type { IUserRepository } from "@src/domain/users/repository/user.repository.interface";
import type { UserDTO } from "../dto/user.dto";
import type { CreateUserInputDTO } from "../dto/user-input.dto";
import { UserDtoMapper } from "../mappers/user-dto.mapper";

/**
 * Use Case: Create User
 * Creates a new user with specific roles (Admin only)
 */
export class CreateUserUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    /**
     * Execute the use case
     * @param data - User creation data
     * @returns Promise<UserDTO> - The created user DTO
     * @throws Error if validation fails
     */
    async execute(data: CreateUserInputDTO): Promise<UserDTO> {
        this.validateCreateData(data);
        const user = await this.userRepository.create(data);
        return UserDtoMapper.toDTO(user);
    }

    /**
     * Validate create data
     * @param data - The data to validate
     * @throws Error if validation fails
     */
    private validateCreateData(data: CreateUserInputDTO): void {
        // Email validation
        if (!data.email || !data.email.trim()) {
            throw new Error('Email is required');
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(data.email)) {
            throw new Error('Invalid email format');
        }

        // Role validation
        if (!data.role_ids || data.role_ids.length === 0) {
            throw new Error('At least one role is required');
        }

        // University is optional (user can set during onboarding)
    }
}
